import React from 'react';
import './../css/footer.css';
import ln_logo from '../assets/icon-linkedin.png';
import x_logo from '../assets/icon-x.png';
import yt_logo from '../assets/icon-youtube.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="objective">
          <p>DEFENDER OF YOUR DIGITAL FRONTIERS</p>
        </div>
        <div className="social-media">
          <a href="https://linkedin.com/company/defensek" target="_blank" rel="noopener noreferrer"><img src={ln_logo} alt="ln-logo" style={{width:'25px',height:'25px'}}/></a>
          <a href="https://x.com/defensek_online" target="_blank" rel="noopener noreferrer"><img src={x_logo} alt="x-logo" style={{width:'25px',height:'25px'}}/></a>
          <a href="https://youtube.com/@DefenseK" target="_blank" rel="noopener noreferrer"><img src={yt_logo} alt="yt-logo" style={{width:'36.6px',height:'25px'}}/></a>
        </div>
      </div>
      <div className="copyright">
        <p>© 2025 DefenseK. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
